import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import OffenceService from '@services/offence'

export const getDemeritConfigurations = createAsyncThunk('demeritConfigurations/getDemeritConfigurations', async (params) => {
  const response = await OffenceService.getDemeritConfigurations(params)
  return { params, data: response.data, totalPages: response.meta.itemCount }
})

export const addDemeritConfiguration = createAsyncThunk('demeritConfigurations/addDemeritConfiguration', async (demeritConfigData, { rejectWithValue }) => {
  try {
    const response = await OffenceService.addDemeritConfiguration(demeritConfigData)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateDemeritConfiguration = createAsyncThunk('demeritConfigurations/updateDemeritConfiguration', async (demeritConfigData, { rejectWithValue }) => {
  try {
    const response = await OffenceService.updateDemeritConfiguration(demeritConfigData)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const deleteDemeritConfiguration = createAsyncThunk('demeritConfigurations/deleteDemeritConfiguration', async (id, { getState, dispatch }) => {
  await OffenceService.deleteDemeritConfiguration(id)
  await dispatch(getDemeritConfigurations(getState()?.demeritConfigurations?.params))
  return id
})

const DemeritConfigSlice = createSlice({
  name: 'demeritConfigurations',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: []
  },
  extraReducers(builder) {
    builder
      .addCase(getDemeritConfigurations.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(updateDemeritConfiguration.fulfilled, (state, action) => {
        if (!action.payload?.id) {
          return
        }
        const { id } = action.payload
        const configs = state.data.filter((config) => config.id !== id)
        state.data = [...configs, action.payload]
      })
  }
})

export const selectDemeritConfigById = (state, id) => state.demeritConfigurations.data.find((config) => config.id === id)
export default DemeritConfigSlice.reducer

// The API's reason (e.g. "This offence already has a level 2 configuration
// for ordinary licences.") when there is one, else its status text.
export const serverReason = (error) => (typeof error?.message === 'string' ? error.message : error?.error)
